import { render, staticRenderFns } from "./MenuModuleExpandable.vue?vue&type=template&id=4096bdb0&scoped=true&"
import script from "./MenuModuleExpandable.vue?vue&type=script&lang=js&"
export * from "./MenuModuleExpandable.vue?vue&type=script&lang=js&"
import style0 from "./MenuModuleExpandable.vue?vue&type=style&index=0&id=4096bdb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4096bdb0",
  null
  
)

export default component.exports